import api from '../api';

export const agreementAPI = {
  list: () => api.get('/api/existing-clients'),
  client: id => api.get(`/api/existing-clients/${id}`),
  add: terms => api.post('/api/existing-clients', terms),
  create: (id, terms) => api.post(`/api/existing-clients/${id}/agreements`, terms),
  update: (id, terms) => api.put(`/api/client-agreements/${id}`, terms),
  action: (id, action, data) => api.post(`/api/client-agreements/${id}/${action}`, data),
  pdf: id => api.get(`/api/client-agreements/${id}/pdf`, { responseType: 'blob' }),
  legacyPdf: id => api.get(`/api/documents/${id}`, { responseType: 'blob' }),
  review: token => api.get('/api/agreement-review', { headers: { 'X-Agreement-Token': token } }),
  publicPdf: (token, key) => api.get(key ? `/api/agreement-review/documents/${key}` : '/api/agreement-review/pdf', {
    headers: { 'X-Agreement-Token': token }, responseType: 'blob'
  }),
  uploadId: (token, docType, file) => {
    const form = new FormData(); form.append('file', file);
    return api.post(`/api/agreement-review/id-documents/${docType}`, form, { headers: { 'X-Agreement-Token': token, 'Content-Type': 'multipart/form-data' } });
  },
  sign: (token, data) => api.post('/api/agreement-review/sign', data, { headers: { 'X-Agreement-Token': token } }),
};

export const errorText = error => {
  const detail = error.response?.data?.detail;
  return Array.isArray(detail) ? detail.map(d => `${d.loc.slice(1).join(' ')}: ${d.msg}`).join('; ') : detail || 'This action could not be completed. Please try again.';
};
export const formatDate = value => value ? new Date(`${value.slice(0, 10)}T12:00:00`).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' }) : 'Not set';
export const money = value => Number(value || 0).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });
export const pricingLabel = terms => terms.pricing_type === 'bas_only' ? `${money(terms.bas_fee)} / BAS return` : terms.pricing_type === 'hourly' ? `${money(terms.hourly_rate)} / hour` : `${money(terms.fixed_fee)} ${terms.pricing_type === 'monthly' ? '/ month' : 'one-off'}`;